import { createEditBlock } from "./base-edit-block";

export const textShortenerBlock = createEditBlock("text-shortener", {
  responseToPatch: (text) => ({ text }),
});
